import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import L from 'leaflet';
import { renderToString } from 'react-dom/server'
import Chip from '@mui/material/Chip';
import {
    visibleAssetsMarkersSelector, detailViewSelector, setDetailView,
    selectVehicleById
} from '../../../features/assets/assetsSlice';
import Typography from '@mui/material/Typography';
import {
    setCenter, setZoom, mapControlSelector, setMapControl
} from '../../../features/map/mapSlice';
import { useMap } from 'react-leaflet';

import 'leaflet-rotatedmarker';



const VehicleIcon = ({ assetId }) => {

    const dispatch = useDispatch();
    const map = useMap();
    const mapControl = useSelector(mapControlSelector);
    const visibleAssetMarkers = useSelector(visibleAssetsMarkersSelector);
    const visible = visibleAssetMarkers.indexOf(assetId) !== -1;

    const assetData = useSelector(state => selectVehicleById(state, assetId));
    const vehicleDevice = assetData && assetData.vehicleDevice;
    const coreData = assetData && assetData.coreData;
    const statusMeta = assetData && assetData.statusMeta;

    const detailView = useSelector(detailViewSelector);

    let lat = 23.5251;
    let lng = 77.8081;
    let heading = 180;

    if (coreData) {
        lat = coreData.lat;
        lng = coreData.lng;
        heading = coreData.heading;
    }

    const markerOnClick = useCallback(
        () => {
            dispatch(setMapControl('asset'));
            dispatch(setDetailView(assetId));
        },
        [dispatch, assetId],
    )

    useEffect(() => {
        if (detailView === assetId && mapControl === 'asset') {
            dispatch(setCenter({ lat, lng }));
        }
    }, [detailView, assetId, lat, lng, dispatch, mapControl]);

    useEffect(() => {
        if (detailView === assetId && mapControl === 'asset') {
            dispatch(setZoom(17));
        }

    }, [detailView, dispatch, assetId, mapControl]);

    const [theIcon, setTheIcon] = useState(null);
    const [theLabel, setTheLabel] = useState(null);

    const createMarker = useCallback(
        () => {
            if (map && vehicleDevice) {
                const { icon } = vehicleDevice;
                const tic = L.marker([lat, lng], {
                    rotationAngle: heading,
                    icon: L.icon({
                        iconUrl: `/assets/markers/def30/${icon}`,
                        //iconSize: [12, 24],
                        iconAnchor: [8, 15],
                    })
                }).on('click', markerOnClick);
                map.addLayer(tic);
                setTheIcon(tic);
            }
        },
        [lat, lng, heading, vehicleDevice, map, markerOnClick],
    )

    const createLabel = useCallback(
        () => {
            if (map && vehicleDevice) {
                const { regn } = vehicleDevice;
                const { colorbg, colorfg } = statusMeta;
                const html = renderToString(
                    <Chip
                        size="small"
                        style={{
                            backgroundColor: colorbg,
                            borderRadius: '2px',
                            position: 'absolute',
                            left: -0,
                            top: 0,
                            whiteSpace: 'nowrap',
                        }}
                        label={
                            <span style={{ color: colorfg, fontSize: 10 }}>&nbsp;<b>{regn}</b>&nbsp;</span>
                        }
                    />
                );
                /*const html = renderToString(
                    <Typography><span style={{ color: colorfg, fontSize: 10 }}>{regn}</span></Typography>
                );*/
                const tlbl = L.marker([lat, lng], {
                    icon: L.divIcon({
                        html: html,
                        iconAnchor: [-7, -8],
                        className: 'dummy'
                    })
                }).on('click', markerOnClick);
                map.addLayer(tlbl);
                setTheLabel(tlbl);
            }
        },
        [lat, lng, vehicleDevice, statusMeta, map, markerOnClick],
    )

    useEffect(() => {
        if (visible) {
            if (!theIcon) {
                createMarker();
                createLabel();
            } else {
                theIcon.setRotationAngle(heading);
                theIcon.setLatLng([lat, lng]);
            }
        }
        return () => {
            if (theIcon) {
                map.removeLayer(theIcon);
                setTheIcon(null);
            }
            if (theLabel) {
                map.removeLayer(theLabel);
                setTheLabel(null);
            }
        }
    }, [theIcon, theLabel, lat, lng, heading, visible, map, createMarker, createLabel])



    return null;


}

export default React.memo(VehicleIcon);

